// client/src/modules/explorer/routes.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

// Central Command pages
const ExecutiveDashboard = lazyWithRetry(() => import('../../pages/DataHub/ExecutiveDashboard'));
const OperationsOverview = lazyWithRetry(() => import('../../pages/CentralCommand/OperationsOverview'));
const SalesOverview = lazyWithRetry(() => import('../../pages/CentralCommand/SalesOverview'));
const FleetOverview = lazyWithRetry(() => import('../../pages/CentralCommand/FleetOverview'));
const DataHealth = lazyWithRetry(() => import('../../pages/CentralCommand/DataHealth'));
const CollectionHealth = lazyWithRetry(() => import('../../pages/CentralCommand/CollectionHealth'));

// Existing data pages
const DataBrowser = lazyWithRetry(() => import('../../pages/DataHub/DataBrowser'));

// Legacy pages (still used by DataHealth)
const Connections = lazyWithRetry(() => import('../../pages/DataHub/Connections'));

/**
 * Central Command module routes - relative to /command prefix
 */
export const routes: RouteObject[] = [
  // Executive Dashboard — landing page
  {
    index: true,
    element: <ProtectedRoute><ExecutiveDashboard /></ProtectedRoute>,
  },
  // Composed overview pages
  {
    path: 'operations',
    element: <ProtectedRoute><OperationsOverview /></ProtectedRoute>,
  },
  {
    path: 'sales',
    element: <ProtectedRoute><SalesOverview /></ProtectedRoute>,
  },
  {
    path: 'fleet',
    element: <ProtectedRoute><FleetOverview /></ProtectedRoute>,
  },
  // Infrastructure
  {
    path: 'health',
    element: <ProtectedRoute><DataHealth /></ProtectedRoute>,
  },
  {
    path: 'collection-health',
    element: <ProtectedRoute><CollectionHealth /></ProtectedRoute>,
  },
  {
    path: 'connections',
    element: <ProtectedRoute><Connections /></ProtectedRoute>,
  },
  {
    path: 'data/:collectionName?',
    element: <ProtectedRoute><DataBrowser /></ProtectedRoute>,
  },
  // Catch-all
  {
    path: '*',
    element: <Navigate to="/command" replace />,
  },
];
